export default __webpack_public_path__ + "static/media/moonriver.3572bce6.svg";